/** Canonical customer-facing support contact channels (web + parity contracts). */
export const SUPPORT_CONTACTS = {
  supportEmail: 'support@ninposnacks.com',
  billingEmail: 'billing@ninposnacks.com',
  ordersEmail: 'orders@ninposnacks.com',
  bottlePickUpsEmail: 'bottlepickups@ninposnacks.com',
  /** E.164 without plus — use `tel:+${SUPPORT_PHONE_E164}` for links */
  phoneE164: '13132798150',
  phoneDisplay: '(313) 279-8150',
  hours: 'Open 24/7 (Subject to store hours and driver availability)'
} as const;

export const supportPhoneTelHref = `tel:+${SUPPORT_CONTACTS.phoneE164}`;
